import {Component, trigger, transition, style, animate, state} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'

import { ProfileService } from './../../../profile/services/profile.service';
import { PopupService } from './../../services/pop-up.service';
import { ErrorService } from './../../services/error.service';

@Component({
    selector: 'pop-up-change-password',
    templateUrl: 'change-password-popup.component.html',
    animations: [
    trigger(
      'popupAnimation',
      [
        transition(
        ':enter', [
          style({opacity: 0}),
          animate('300ms', style({'opacity': 1}))
        ]
      ),
      transition(
        ':leave', [
          style({'opacity': 1}),
          animate('300ms', style({'opacity': 0}))
        ]
      )]
    )
  ],
})

export class ChangePasswordPopupComponent {

    constructor(
        private _popupService: PopupService,
        private _errorService: ErrorService,
        private _profileService: ProfileService
    ) {
        
    }

    ngOnInit(){
        this._profileService.resetError();
        this._profileService.resetChangePasswordData();
    }

    getPopupOption() {
        return this._popupService.popUpOptions;
    }

    getChangePasswordFlag() {
        return this._popupService.getChangePasswordFlag();
    }

    getChangePasswordData(){
        return this._profileService.getChangePasswordData();
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    getBackEndError(){
        return this._errorService.getBackEndError();
    }

    isDisableSubmit(){
        return this._profileService.isDisableChangePassword();
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/popup/change-password-popup.component.ts